import { isSiteAdmin } from "app/lib/utils/adaya/AdayaUtils";

export const menuItems = [
    {
        key: 'overview',
        label: 'Overview',
        link: '/overview',
        icon: '/static/icons/adaya/hub.svg',
        iconWidth: 20,
        requiredAccountAge: 0
    },
    {
        key: 'quantum-tracking',
        label: 'Quantum Pixel',
        icon: '/static/icons/adaya/Adaya_Product_Quantum_Shortcuts.svg',
        iconWidth: 24,
        sub: [
            {
                key: 'ads-manager',
                label: 'Ads Manager',
                link: '/ads-manager'
            },
            // hide for now
            // {
            //     key: 'purchase-journey',
            //     label: 'Purchase Journey',
            //     link: '/user-journeys',
            //     requiredAccountAge: 8
            // },
            // {
            //     key: 'quantum-feed',
            //     label: 'Quantum Feed',
            //     link: '/tracking/feed',
            //     requiredAccountAge: 8
            // }
            {
                key: 'predictive-roas',
                label: 'Predictive ROAS',
                link: '/campaigns'
            }
        ]
    },
    {
        key: 'shopify-store-goals',
        label: 'Profit OS',
        icon: '/static/icons/adaya/Adaya_Product_Trends_Catcher.svg',
        iconWidth: 18,
        sub: [
            {
                key: 'efficienty-ratio',
                label: 'Efficiency Ratio',
                link: '/mer'
            },
            {
                key: 'goal-tracker',
                label: 'Goal Tracker',
                link: '/goals'
            },
            {
                key: 'goal-studio',
                label: 'Goal Studio',
                link: '/goals/edit'
            },
            {
                key: 'daily-velocity',
                label: 'Daily Velocity',
                link: '/track'
            },
            {
                key: 'trend-catcher',
                label: 'Trend Catcher',
                link: '/trends'
            },
            {
                key: 'instant-insights',
                label: "Mark's Insights",
                link: '/insights'
            }
        ]
    }
];

export const footerMenuItems = [
    {
        key: 'answers',
        label: 'Answer Cloud',
        link: '/answers',
        icon: '/static/icons/adaya/Adaya_Product_Answer_Cloud.svg',
        iconWidth: 16
    },
    {
        key: 'help',
        label: 'Help',
        //link: '/support',
        link: '/answers',
        icon: '/static/icons/adaya/Adaya_Company_Support.svg',
        iconWidth: 18
    },
    {
        key: 'account',
        label: 'Account',
        link: '/account',
        icon: '/static/icons/adaya/Adaya_Company_About_Us.svg',
        iconWidth: 24
    },
    {
        key: 'admin',
        label: 'Admin',
        link: '/admin',
        icon: '/static/icons/adaya/Adaya_Company_About_Us.svg',
        iconWidth: 24,
        hideMenu: true,
        require: (state) => state.user && isSiteAdmin(state.user)
    },
    {
        key: 'logout',
        label: 'Log Out',
        link: '/logout'
    }
];